/**
 * TAB 切换功能模块
 * 功能：实现 TAB 标签页的切换显示
 * 使用：通过 data-id 属性关联 TAB 链接和内容区域
 */
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  /**
   * 初始化 TAB 切换功能
   */
  var tabLinks = document.querySelectorAll('.tab-a');
  
  tabLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      var dataId = this.getAttribute('data-id');

      // 移除所有 TAB 内容区域的 active 状态
      document.querySelectorAll('.tab').forEach(function (tab) {
        tab.classList.remove('tab-active');
      });

      // 显示对应的 TAB 内容
      var targetTab = document.querySelector(".tab[data-id='" + dataId + "']");
      if (targetTab) {
        targetTab.classList.add('tab-active');
      }

      // 移除所有 TAB 链接的 active 状态
      tabLinks.forEach(function (link) {
        link.classList.remove('active-a');
      });

      // 为当前点击的链接添加 active 状态
      this.classList.add('active-a');
    });
  });
});

